export default {
  data() {
    return {
      paginationStart: [{text: 'Użycie spowoduje przejście do poprzedniej strony'}, {text: 'Brak możliwości przejścia do poprzedniej strony'}],
      paginationEnd: [{text: 'Użycie spowoduje przejście do następnej strony'}, {text: 'Brak możliwości przejścia do następnej strony'}]
    };
  },
  methods: {
    isError(field) {
      if (field) return true;
      return false;
    }
  }
};
